import React from 'react';
import { Card as ReactCard, CardBody as ReactCardBody } from 'reactstrap';
import styled, { css } from 'styled-components';
import { dropIn } from '../animations';

interface Props {
    children: React.ReactNode,
    flex?: boolean;
    flexDirection?: 'row' | 'column';
    className?: string;
    bodyClassName?: string;
    onClick?: (props?: any) => any;
    strongShadow?: boolean;
    dropIn?: boolean;
    backgroundColor?: string;
    // All other props
    [x:string]: any;
}

export default function Card ({
    children,
    flex,
    flexDirection,
    className,
    bodyClassName,
    onClick,
    strongShadow,
    dropIn,
    backgroundColor
}: Props) {

    return (
        <Outer 
            className={className} 
            onClick={onClick}
            strongShadow={strongShadow}
            dropIn={dropIn}
        >
            <CardBody 
                className={bodyClassName} 
                flex={flex} 
                flexDirection={flexDirection}
                backgroundColor={backgroundColor}
            >
                { children }
            </CardBody>
        </Outer>
    );
}

const Outer = styled(ReactCard)`
    border-radius: 15px;
    width: 100%;
    background-color: rgba(255,255,255,1);
    box-shadow: ${p => p.strongShadow && '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'};
    animation: ${p => p.dropIn ? css`${(dropIn)} 500ms` : null};
`;

const CardBody = styled(ReactCardBody)`
    border-radius: 15px;
    display: ${p => p.flex ? 'flex' : null};
    flex-direction: ${p => p.flexDirection || null};
    background-color: ${p => p.backgroundColor || null};
`;